module.exports = __webpack_public_path__ + "static/homeVideoMobileWebm2-muted-2c2c68da1e6644edcfd7c9145ded440a.webm";